// Ordenação da listagem do Cadastro de Usuários do Workflow: por nível hierárquico crescente
// (N1 → N7), mantendo juntos os usuários do mesmo nível (desempate por nome). Quem não tem nível
// fica por último. É uma função pura aplicada na renderização, então vale também depois de
// recarregar a tela e reflete na hora uma alteração de nível salva.

export const ordenarPorNivel = <T extends { nome: string; wfNivel?: number | null }>(usuarios: T[]): T[] =>
  [...usuarios].sort((a, b) => {
    const nivelA = a.wfNivel || Number.POSITIVE_INFINITY;
    const nivelB = b.wfNivel || Number.POSITIVE_INFINITY;
    if (nivelA !== nivelB) return nivelA < nivelB ? -1 : 1;
    return a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' });
  });
